module.exports = __webpack_public_path__ + "static/media/R.ab1f63ec.png";